module.exports = __webpack_public_path__ + "static/media/48361065_2308770449198133_6792481595983921152_o-thumb.7a5e3cc9.jpg";